/*
 * Copyright 2025 Intuition Robotics ltd
 */
import {RoutingModule} from "@intuitionrobotics/thunderstorm/frontend";
import {Route_Alerts, Route_Default, Route_PatientsHome} from "../../Routes";
import {COLORS} from "@res/colors";
import {AnalyticConsts, AnalyticsModule} from "@modules/AnalyticsModule";
import React from "react";
import {Badge} from "../widget/Badge";
import {AlertDot} from "./alerts/AlertBadge";
import {FONTS} from "@res/fonts";
import {UserPreferencesModule} from "@modules/UserPreferencesModule";
import {useHistory} from "react-router-dom";

type Props = { routeKeys: string[], icon: (color?: string, width?: number) => React.JSX.Element, title: string, showDot?: boolean }

export const LeftPanelSection = ({routeKeys, icon, title, showDot}: Props) => {
    // const location = useLocation();
    const history = useHistory();
    // const redirectToHome = () => {
    //     const queryParams = new URLSearchParams(location.search);
    //     queryParams.delete(PARAM_PATIENT);
    //     history.push({
    //         pathname: location.pathname,
    //         search: queryParams.toString(),
    //     });
    //     return RoutingModule.redirect(Route_Default);
    // };


    const selected = !!routeKeys.find(r => r === (RoutingModule.getMyRouteKey() || Route_Default));
    const navigateToRoute = () => {
        const key = routeKeys[0];
        if (RoutingModule.getMyRouteKey() === key)
            return;

        if ([Route_PatientsHome,
            Route_Alerts].includes(key))
            UserPreferencesModule.setLastMainRoute(key);

        // const patient = BaseComponent.getQueryParameter(PARAM_PATIENT);
        // const params = patient ? {[PARAM_PATIENT]: patient} : undefined;
        const route = RoutingModule.getRoute(key);
        history.push({pathname: route.path});
        AnalyticsModule.logCareManagerEvent({
            objectType: key,
            entity: AnalyticConsts.Entities.USER,
            activityStatus: AnalyticConsts.ActivityStatus.VIEW
        });

    };
    return <div
        className={`match_width ll_v_c clickable`}
        style={{
            justifyContent: "center",
            height: 100, backgroundColor: selected ? COLORS.primary_blue : COLORS.primary_dark_blue
        }}
        onClick={navigateToRoute}
    >
        <div style={{height: 48}}>
            <Badge
                show={!!showDot}
                top={13}
                right={17}
                badge={<div className={AlertDot}/>}
            >
                {icon(selected ? COLORS.white : COLORS.primary_light_blue, 48)}
            </Badge>
        </div>
        {selected ? FONTS.bold_14_white(title) : FONTS.reg_14_lightblue(title)}
    </div>;
}
